<template>
  <div class="footer">
    <div class="links" v-if="!mobile">
      <b-row>
        <b-col sm="3">
          <b-col>
            <a href="/viviendas-venta">Viviendas en venta</a>
          </b-col>
          <b-col>
            <a href="/viviendas-pontevedra">Viviendas en Pontevedra</a>
          </b-col>
          <b-col>
            <a href="/casas-pontevedra">Casas en Pontevedra</a>
          </b-col>
          <b-col>
            <a href="/pisos-pontevedra">Pisos en Pontevedra</a>
          </b-col>
        </b-col>

        <b-col sm="3">
          <b-col>
            <a href="/viviendas-alquiler">Viviendas en alquiler</a>
          </b-col>
          <b-col>
            <a href="/oficinas-venta">Oficinas en venta</a>
          </b-col>
          <b-col>
            <a href="/oficinas-alquiler">Oficinas en alquiler</a>
          </b-col>
          <b-col>
            <a href="/oficinas-pontevedra">Oficinas en Pontevedra</a>
          </b-col>
        </b-col>

        <b-col sm="3">
          <b-col>
            <a href="/locales-venta">Locales en venta</a>
          </b-col>
          <b-col>
            <a href="/locales-alquiler">Locales en alquiler</a>
          </b-col>
          <b-col>
            <a href="/locales-traspaso">Locales en traspaso</a>
          </b-col>
          <b-col>
            <a href="/locales-pontevedra">Locales en Pontevedra</a>
          </b-col>
        </b-col>

        <b-col sm="3">
          <b-col>
            <a href="/fincas-venta">Fincas en venta</a>
          </b-col>
          <b-col>
            <a href="/fincas-pontevedra">Fincas en Pontevedra</a>
          </b-col>
          <b-col>
            <a href="/garajes-venta">Plaza de garaje en venta</a>
          </b-col>
          <b-col>
            <a href="/garajes-alquiler">Plaza de garaje en alquiler</a>
          </b-col>
        </b-col>
      </b-row>
    </div>

    <footer class="copy">
      <b-row>
        <b-col md="6" v-if="!mobile">
          <span>Copyright © 2019 · Versada Inmobiliaria</span>
          -
          <a href="/cookies">Política de cookies</a>
          -
          <a href="/lopd">Política de privacidad</a>
        </b-col>
        <b-col md="6">
          <span>
            Encuéntranos en:
            <a href="https://www.facebook.com/Versada-Inmobiliaria-112092750270921/" target="_blank">
              <i class="fab fa-facebook-square icon"></i>
            </a>
            <a href="https://www.instagram.com/versada_inmobiliaria/" target="_blank">
              <i class="fab fa-instagram icon"></i>
            </a>
          </span>
        </b-col>
        <b-col md="4" v-if="mobile">
          <a href="/cookies">Política de cookies</a>
          -
          <a href="/lopd">Política de privacidad</a>
        </b-col>
        <b-col md="4" v-if="mobile">
          <span>Copyright © 2019 · Versada Inmobiliaria</span>
        </b-col>
      </b-row>
    </footer>
  </div>
</template>

<script>

export default {
  name: "Footer",
  computed: {
    mobile: function() {
      if (screen.width <= 760) {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>

<style>
.links {
  background-color: #0085ca;
  padding: 10px;
  margin-top: 50px;
  padding-bottom: 30px;
}
.footer {
  color: #fff;
  bottom: 0;
}
.footer a {
  color: #fff;
}

.icon {
  margin-right: 5px;
  margin-left: 10px;
  font-size: 25px;
}
.copy {
  background-color: rgb(20, 20, 20);
  padding: 5px 15px;
}
</style>